module.exports = __webpack_public_path__ + "static/media/068-bell.b1b5cbb2.svg";